<script>
  import { mapGetters, mapMutations } from 'vuex'

  export default {
    computed: {
      ...mapGetters(['getUser', 'hasUser', 'getPolicies']),
      isSuperUser() {
        return this.getUser && this.getUser.superUser
      }
    },
    methods: {
      ...mapMutations(['setUser'])
    },
    name: 'GetUser'
  }
</script>
